<!--
 * @Description: 意见反馈
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 11:05:54
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span></span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text">
          <v-list-item two-line>
            <v-list-item-content>
              <!-- <v-list-item-subtitle>账号</v-list-item-subtitle> -->
              <v-list-item-title>
                <!-- 输入框 -->
                <v-col cols="12" md="12">
                  <v-textarea
                    outlined
                    name="input-7-4"
                    :label="`* 问题和意见(5-200)`"
                    color="black"
                    :no-resize="true"
                     maxlength="200"
                     counter="200"
                    v-model.trim="valueText"
                  ></v-textarea>
                  <v-text-field label="联系方式(选填)" maxlength="11" outlined color="black" v-model.trim="value"></v-text-field>
                  <v-btn block color="indigo" x-large :disabled="valueText.length < 5" dark @click="sub"> 提交 </v-btn>
                </v-col>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <!-- <v-btn color="primary" text @click="dialog = false">Close</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      valueText: "",
      value: ''
    };
  },
  methods: {
    info(state) {
      this.dialog = state;
    },
    testNumber(val){
      var reg = /^[1-9]\d*$/;
      return reg.test(val);
    },
    /* 提交问题和意见 */ 
    sub(){
      if( this.valueText.length < 5 ){
        this.$Dialog.getProductCheckResult_({text: `请输入问题好意见（5-200）`,timeout: 3000, snackbar: true });
        return
      }
      if( this.value !== '' ){
        if( !this.testNumber(this.value) ){
          this.$Dialog.getProductCheckResult_({text: `请输入正确的联系方式`,timeout: 3000, snackbar: true });
          return
        }
      }
      this.$axios({
        method: "post",
        url: this.$apis.URL.user_feedback,
        data: {
          type: 1,
          content: this.valueText,
          contact: this.value
        }
      })
        .then((req) => {
          if(req.data.result == 0){
            this.dialog = false;
            this.$Dialog.getProductCheckResult_({text: `用户反馈已提交，感谢您的支持！`,timeout: 3000, snackbar: true });
          }else{
            this.$Dialog.getProductCheckResult_({text: req.data.message,timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({text: error,timeout: 3000, snackbar: true });
        });
    }

  }
};
</script>